// FT-066: native @rails/actioncable service (replaces the legacy name-keyed WS wrapper).
// Single consumer per tab; subscriptions are objects with handlers on them
// (no name-keyed registry → no collisions). urlFn is re-evaluated by the native
// consumer on every (re)connect → fresh token/region. SECURITY: never log the tokenized URL.
import { createConsumer as defaultCreateConsumer } from "@rails/actioncable";

let consumer = null;

// createConsumerImpl is injectable for tests (the only external dependency).
export function initCable(urlFn, createConsumerImpl = defaultCreateConsumer) {
  consumer = createConsumerImpl(urlFn);
  return consumer;
}

export function subscribe(params, handlers) {
  if (!consumer) {
    throw new Error("[cable] initCable() must be called before subscribe()");
  }
  return guardUnsubscribe(consumer.subscriptions.create(params, handlers));
}

// unsubscribe() шлёт команду на сервер, только пока сервер эту подписку держит.
// @rails/actioncable 8.0 на reject_subscription забывает подписку локально, а сервер удаляет
// её у себя; но Subscriptions#remove всё равно отправляет "unsubscribe", если других
// подписок с тем же identifier не осталось. То же при повторном unsubscribe(). Сервер
// отвечает на это level=error «Unable to find subscription with identifier» (Loki, все каналы).
// Отклонённая подписка мертва навсегда: reload() на реконнекте её не воскрешает.
// Регрессия: tests/unit/cable/cable-unsubscribe-after-reject.spec.js
function guardUnsubscribe(subscription) {
  if (!subscription || typeof subscription.unsubscribe !== "function") return subscription;

  let serverDropped = false;
  const appRejected = subscription.rejected;
  const libUnsubscribe = subscription.unsubscribe;

  subscription.rejected = function (...args) {
    serverDropped = true;
    return typeof appRejected === "function" ? appRejected.apply(this, args) : undefined;
  };
  subscription.unsubscribe = function () {
    if (serverDropped) return this;
    serverDropped = true;
    return libUnsubscribe.call(this);
  };
  return subscription;
}

export function reconnect() {
  if (!consumer) return;
  consumer.disconnect();
  consumer.connect();
}

export function disconnect() {
  if (!consumer) return;
  consumer.disconnect();
}

export function getConsumer() {
  return consumer;
}

// Test seam: reset module singleton between tests.
export function __resetForTests() {
  consumer = null;
}
